export default __webpack_public_path__ + "static/media/tick2.fb6f90d2.svg";